import axios from '@/api/provider'

/**
 * Health / version API service
 * Reads the backend health payload (status, version, environment) from the
 * API root endpoint (`GET /`).
 */

/**
 * Fetch the backend version and health status.
 * @returns {Promise<{status: string, version: string, environment: Object}>}
 */
const getHealth = async () => {
  return axios.get('/').then((response) => ({
    status: response.status,
    version: response.version,
    environment: response.environment,
  }))
}

export default {
  getHealth,
}
